import {
  Container, Box, Button
} from '@mui/material';
import { useHistory } from 'react-router-dom';

import { useStyles } from './style';

export const NoProfile = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Container maxWidth="md" className={classes.NoProfileContainer}>
      <Box className={classes.noProfileContent}>
        <Box className={classes.textWrap}>
          <Box className={classes.semiBoldText}>We couldn&apos;t find anyone matching that information. </Box>
          <Box className={classes.normalText}>Please check your entries and try again, or arrive early to your first collection with enough time to register in-person.</Box>
        </Box>
        <Button onClick={() => history.replace('/login')} className={classes.tryAgainBtn} variant="contained" color="secondary">
          Try Again
        </Button>
      </Box>
    </Container>
  );
};
